import PropTypes from 'prop-types';
import React, { useState } from 'react';

import * as S from './Dropdown.styles';

export const Dropdown = ({ disabled, main, content, isFullWidth }) => {
  if (!content || !main) {
    return null;
  }

  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <S.DesktopContainer
      isFullWidth={isFullWidth}
      onMouseEnter={!disabled ? open : undefined}
      onMouseLeave={close}
    >
      <S.Wrapper isFullWidth={isFullWidth}>
        {main({ isOpen, open, close })}
      </S.Wrapper>
      {!disabled && (
        <S.Drawer isOpen={isOpen}>{content({ isOpen, open, close })}</S.Drawer>
      )}
    </S.DesktopContainer>
  );
};

Dropdown.propTypes = {
  /**
    Default value of content elements before one of them becomes selected
    */
  content: PropTypes.func.isRequired,
  /**
   * Disable the dropdown.
   */
  disabled: PropTypes.bool,
  /**
   * Display a wide dropdown.
   */
  isFullWidth: PropTypes.bool,
  /**
    Elements displayed in the dropdown menu.
    */
  main: PropTypes.func.isRequired,
};

Dropdown.defaultProps = {
  isFullWidth: false,
};
